import { useState } from 'react';
import styles from './Billing.module.css';

import GeneratedInvoice from './GeneratedInvoice/GeneratedInvoice';
import CreditBalance from './CreditBalance/CreditBalance';

import ThreeDotMenu from '../../../components/ThreeDotMenu/ThreeDotMenu';
import { useDispatch } from 'react-redux';
import { openModal } from '../../../redux/slices/modalSlice';
import DebitTab from './DebitTab/DebitTab';
import UpcomingInvoices from './UpcomingInvoices/UpcomingInvoices';
import FeePlan from './FeePlan/FeePlan';
import DepositTab from './DepositTab/DepositTab';

function Billing() {
  const dispatch = useDispatch();
  const tab = [
    {
      label: 'Generated Invoice',
      content: <GeneratedInvoice />,
    },
    {
      label: 'Credit Balance',
      content: <CreditBalance />,
    },
    {
      label: 'Debit',
      content: <DebitTab />,
    },
    {
      label: 'Deposit',
      content: <DepositTab />,
    },
    {
      label: 'Upcoming Invoices',
      content: <UpcomingInvoices />,
    },
    {
      label: 'Fee Plan',
      content: <FeePlan />,
    },
  ];

  const [activeTab, setActiveTab] = useState(tab[0].label);
  const ActionOptions = [
    {
      label: 'Add Credit Balance',
      onClick: () => dispatch(openModal('addCredit')),
    },
    {
      label: 'Add Deposit',
      onClick: () => dispatch(openModal('addDeposit')),
    },
    {
      label: 'Add Debit',
      onClick: () => dispatch(openModal('createDebitNotes')),
    },
    {
      label: 'Create Invoice',
      onClick: () => dispatch(openModal('accountingInvoice')),
    },
  ];
  return (
    <div className={styles.Billing}>
      <div className={styles.maincontainer}>
        <div className={styles.container}>
          {tab.map((item, index) => {
            return (
              <div
                key={index}
                className={`${styles.tabOptions} ${
                  activeTab === item.label && styles.ActivetabOption
                }`}
                onClick={() => setActiveTab(item.label)}
              >
                {item.label}
              </div>
            );
          })}
          <ThreeDotMenu options={ActionOptions} />
        </div>
      </div>

      {tab.map((item) =>
        activeTab === item.label ? <>{item.content}</> : null
      )}
    </div>
  );
}

export default Billing;
